import { Box, Icons, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';
import type { Post } from '@core/types/state';
import { createStyles } from './PinnedPosts.styles';
import SidebarPinnedPost from './PinnedPost';
import NoResultsCard from '@app/components/presentational/common/NoResults/NoResultsCard';

type Props = {
  pinnedPosts: Post[];
};

const SidebarPinnedPosts = ({ pinnedPosts }: Props) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Box sx={styles.headerContent}>
          <Icons.PushPinOutlined sx={styles.headerIcon} />
          <Box>All pinned post ({pinnedPosts.length})</Box>
        </Box>
      </Box>
      {pinnedPosts && pinnedPosts.length > 0 && (
        <Box
          sx={styles.list}
          tabIndex={0}
          role="region"
          aria-label="Pinned posts"
        >
          {pinnedPosts.map((pinnedPost) => (
            <SidebarPinnedPost key={pinnedPost.objectId} post={pinnedPost} />
          ))}
        </Box>
      )}
      {pinnedPosts && pinnedPosts.length == 0 && (
        <NoResultsCard
          title="No pinned post"
          description="Pin an important post to keep it easily accessible here."
          sx={styles.emptyList}
          titleSx={styles.emptyTitle}
        />
      )}
    </Box>
  );
};

export default SidebarPinnedPosts;
